import QualifiedContractPage from '@/components/Layout/SellerAgent/QualifiedContractPage';

export const QualifiedContractAgentPage = () => {
  return <QualifiedContractPage />;
};
